import React, { useEffect, useState, useContext, useRef } from 'react';
import ApplicationContext from '../../context/AppContext';
import './Header.scss';
import * as constants from '../../constants/constants';
import Modal from 'react-modal';
import { GC } from '../../services/config/gamecentreService';
import { storage } from '../../services/config/storage';


const Header = (props) => {
    const timeInSeconds = constants.GAME_TIME;
    const { context, setContext, timer, setTimer, showHeader,showTutorial } = useContext(ApplicationContext);
    const timerRef = useRef(0);
    const [showModal, setShowModal] = useState(false);
    timerRef.current = timer;
    const timerInterval = useRef()

    const startTimeInterval = () => {
        timerInterval.current = setInterval(() => {
            setTimer(time => time - 1)
        }, 1000)
    }

    const endTimeInterval = (e) => {
        if(e?.type !== constants.PAUSE_TIMER_EVENT) {
            setTimer(null)
        }
        clearInterval(timerInterval.current)
    }

    useEffect(() => {
        if(!showTutorial) {
            startTimeInterval()
        }
    }, [showTutorial])
    
    useEffect(() => {
        if(timer === 0) {
            endTimeInterval()
        }
    }, [timer])

    useEffect(() => {
        window.addEventListener(constants.PAUSE_TIMER_EVENT, endTimeInterval)
        window.addEventListener(constants.RESUME_TIMER_EVENT, startTimeInterval)
        return () => {
            window.removeEventListener(constants.PAUSE_TIMER_EVENT, endTimeInterval)
            window.removeEventListener(constants.RESUME_TIMER_EVENT, startTimeInterval)    
        }
        // document.getElementById("audio-player").play();
        // document.getElementById("audio-player").muted = !document.getElementById("audio-player").muted;
    }, []);

    const renderGameTitle = () => {
        if(showTutorial) {
            return <h2 className="chapter">Tutorial</h2>
        }
        return context.currentLevel ? <h2 className="chapter">{`Chapter ${context.currentLevel} of 2`}</h2> : <h2 className="chapter">{`Game Complete`}</h2>;
    }

    return (
        <div className="header">
            {

                <React.Fragment>
                    {/* <button className="display-mob" onClick={() => setShowModal(true)}><CrossIcon /></button> */}
                    <div className="display-mob"></div>
                    {renderGameTitle(renderGameTitle)}
                    {timer ?
                        <div className="timer">
                            <div className="overlay" style={{ width: `${329 * ((((timerRef.current) * 100) / timeInSeconds) / 100)}px` }}></div>
                            <span>{`00:${timer < 10 ? '0' + timer : timer}`}</span>
                        </div> : null}
                    <div className="mobile-timer">
                        <p>{context.currentLevel ? "LEVEL " + context.currentLevel : ""}</p>
                        <span>{timer ? `00:${timer < 10 ? '0' + timer : timer}` : null}</span>
                    </div>
                    <div className="buttons">
                        {/* <button onClick={() => {
                            document.getElementById("audio-player").play();
                            document.getElementById("audio-player").muted = !document.getElementById("audio-player").muted;
                        }}><SpeakerIcon /></button> */}
                        <button onClick={() => setShowModal(true)} className="display-desktop"><CrossIcon /></button>
                    </div>
                    {/* <audio loop autoplay muted id="audio-player" >
                        <source src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3" type="audio/ogg" />
                    </audio> */}
                </React.Fragment>

            }
            <Modal
                isOpen={showModal}
                onRequestClose={() => setShowModal(false)}
                overlayClassName="Overlay"
                contentLabel="Example Modal"
                className="Modal"
            >
                <h1>Do you want to end the game ?</h1>
                <p>You still have time left.</p>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <button className="end-btn" onClick={() => {
                        setTimer(null);
                        setTimeout(() => {
                            GC.sendGameEndMessage();
                            storage.destroy.all()
                        }, 1000);
                    }}>END GAME</button>
                    <button className="cancel-btn" onClick={() => setShowModal(false)}>CANCEL</button>
                </div>
            </Modal>
        </div>
    );
}

const CrossIcon = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.6619 3.70154C15.244 2.99647 15.2052 1.95101 14.5455 1.29132C13.8446 0.590394 12.7082 0.590394 12.0072 1.29132L7.83713 5.46143L3.74764 1.37195L3.61961 1.25553C2.91453 0.67345 1.86907 0.712255 1.20938 1.37195C0.508457 2.07287 0.508458 3.20929 1.20938 3.91021L5.29886 7.99969L1.12896 12.1696L1.01255 12.2976C0.430466 13.0027 0.469272 14.0482 1.12896 14.7079C1.82989 15.4088 2.9663 15.4088 3.66723 14.7079L7.83713 10.538L11.9265 14.6273L12.0545 14.7437C12.7596 15.3258 13.8051 15.287 14.4648 14.6273C15.1657 13.9264 15.1657 12.79 14.4648 12.0891L10.3754 7.99969L14.5455 3.82958L14.6619 3.70154Z" fill="#C3C3C3" />
</svg>

const SpeakerIcon = () => <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.19248 4.87829L8.88853 1.2373C9.71952 0.594775 10.9177 1.19836 10.9177 2.2303V14.8277C10.9177 15.8986 9.73884 16.4827 8.90786 15.8402L4.19248 12.1992H1.89276C1.29368 12.1992 0.810547 11.7124 0.810547 11.1089V5.96864C0.810547 5.36505 1.29368 4.87829 1.89276 4.87829H4.19248ZM16.3869 2.65878C16.0004 2.34726 15.4399 2.42514 15.1114 2.79508C14.8022 3.18449 14.8409 3.7686 15.2274 4.08013C16.5028 5.15101 17.3338 6.74759 17.3338 8.53888C17.3338 10.3302 16.5028 11.9462 15.2274 12.9976C14.8409 13.3092 14.8022 13.8933 15.1114 14.2827C15.4206 14.6721 16.0004 14.75 16.3869 14.4385C18.0875 13.056 19.1891 10.9338 19.1891 8.55835C19.1697 6.16348 18.0875 4.04119 16.3869 2.65878ZM14.2808 5.26774C13.8943 4.95621 13.3145 4.99515 12.986 5.40403C12.6575 5.81291 12.7348 6.39703 13.1406 6.72803C13.6624 7.15638 13.9909 7.81838 13.9909 8.53879C13.9909 9.31761 13.6237 9.99908 13.044 10.4274C12.6768 10.7 12.6188 11.2452 12.9087 11.5957L12.986 11.6735C13.2952 12.0435 13.8749 12.1214 14.2421 11.8293C15.2084 11.07 15.8268 9.86278 15.8268 8.53879C15.8268 7.21479 15.2277 6.04656 14.2808 5.26774Z" fill="#C3C3C3" />
</svg>

export default Header;